<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Auto Escalation"
    :view-input="autoEscalation"
    :form="$v.editableDesign"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">Does the plan use Auto-Increase?</div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-auto-increase-select
            :design="$v.editableDesign"
          ></roe-auto-increase-select>
        </div>
      </div>
      <template v-if="showAutoIncrease(editableDesign)">
        <template v-if="showAutoIncreasePriorEmployees(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">Applies to Prior Employees</div>
          </div>
          <div class="right-panel-form-row-wrap">
            <roe-auto-increase-applies-prior-employees-radio
              :design="$v.editableDesign"
            ></roe-auto-increase-applies-prior-employees-radio>
          </div>
        </template>
        <div class="right-panel-label-wrap">
          <div class="light-label">Auto-Increase Contribution Type</div>
        </div>
        <div class="right-panel-form-row-wrap">
          <roe-auto-increase-type-radio :design="$v.editableDesign">
          </roe-auto-increase-type-radio>
        </div>
        <div class="right-panel-label-wrap">
          <div class="light-label">Annual</div>
          <div class="light-label">Max</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-auto-increase-annual-percent-input :design="$v.editableDesign">
            </roe-auto-increase-annual-percent-input>
          </div>
          <div class="form-unit">
            <roe-auto-increase-max-percent-input
              :design="$v.editableDesign"
            ></roe-auto-increase-max-percent-input>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">Auto Increase Date Type</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-auto-increase-date-type-select
              :design="$v.editableDesign"
            ></roe-auto-increase-date-type-select>
          </div>
        </div>
      </template>
    </div>

    <template v-slot:survey>
      <roe-survey-bar label="None" :percent="survey.auto_increase.none"></roe-survey-bar>
      <roe-survey-bar label="Voluntary" :percent="survey.auto_increase.voluntary"></roe-survey-bar>
      <roe-survey-bar label="Mandatory" :percent="survey.auto_increase.mandatory"></roe-survey-bar>
      <roe-survey-bar label="0% - 2%" :percent="survey.auto_increase.percent0_2"></roe-survey-bar>
      <roe-survey-bar label="2% - 4%" :percent="survey.auto_increase.percent2_4"></roe-survey-bar>
      <roe-survey-bar label="4% - 6%" :percent="survey.auto_increase.percent4_6"></roe-survey-bar>
      <roe-survey-bar label="6% - 8%" :percent="survey.auto_increase.percent6_8"></roe-survey-bar>
      <roe-survey-bar label="8% - 10%" :percent="survey.auto_increase.percent8_10"></roe-survey-bar>
      <roe-survey-bar label="10% - 12%" :percent="survey.auto_increase.percent10_12"></roe-survey-bar>
      <roe-survey-bar label="> 12%" :percent="survey.auto_increase.percent12plus"></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBarLight from "@/components/charts/SurveyBarLight";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import { mapGetters } from "vuex";
import {
  RoeAutoIncreaseSelect,
  RoeAutoIncreaseTypeRadio,
  RoeAutoIncreaseAnnualPercentInput,
  RoeAutoIncreaseMaxPercentInput,
  RoeAutoIncreaseAppliesPriorEmployeesRadio,
  RoeAutoIncreaseDateTypeSelect
} from "@/components/_shared/inputs/design/auto-increase";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";

export default {
  name: "RoeAutoEscalation",
  components: {
    RoeAutoIncreaseAppliesPriorEmployeesRadio,
    RoeAutoIncreaseSelect,
    RoeAutoIncreaseTypeRadio,
    RoeAutoIncreaseAnnualPercentInput,
    RoeAutoIncreaseMaxPercentInput,
    RoeAutoIncreaseDateTypeSelect,
    RoeSurveyBar,
    RoeSurveyBarLight,
    RoePlanDesignEditForm
  },
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  mixins: [AutoIncreaseMixin],
  validations() {
    return {
      editableDesign: this.validations
    };
  },
  computed: {
    ...mapGetters(["editableDesign", "autoEscalation", "originalDesign", "survey"]),
    validations() {
      let validations = this.autoIncreaseValidations(this.editableDesign);
      delete validations.auto_increase_effective_date;
      return validations;
    }
  }
};
</script>
